import React from "react";
import { Box, Button, Dialog, MenuItem, TextField } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import PageTitle from "../../../components/PageTitle";
import { MessageDialog } from "../../../components/message-dialog";
import { OralModel, oralModelToDetails } from "../../../models/Oral.model";
import { getPeriodLabel } from "../../../utils/period-label";
import { OralDetail } from "./OralDetail/oral-detail";
import { Loading } from "../../../components/loading";
import { AdminFilterBar, AdminPageHeader, countLabel, DataTable, EmptyState } from "../../../components/ui";
import { useManageOral } from "./use-manage-oral";
import { buildOralColumns } from "./oral-columns";
import OralFormModal from "./components/OralFormModal";

export const ManageOral = () => {
    const {
        formik,
        formOpen,
        closeForm,
        openCreate,
        productViewModel,
        setProductViewModel,
        productViewInitial,
        productSchema,
        btnSaveDisabled,
        selectedClasses,
        filterArray,
        setClasses,
        saveFilter,
        handleAddClass,
        handleRemoveClass,
        autoCompletefilter,
        open,
        setOpen,
        selectedProduct,
        dialogModel,
        openBackdrop,
        allActives,
        searchTerm,
        setSearchTerm,
        selectedPeriod,
        setSelectedPeriod,
        selectedClassification,
        setSelectedClassification,
        page,
        setPage,
        pageSize,
        distinctClassifications,
        filteredActives,
        pagedActives,
        handleClickEnable,
        handleClickEditActive,
        handleClickViewActive,
    } = useManageOral();

    const tableColumns = buildOralColumns({
        onToggle: handleClickEnable,
        onEdit: handleClickEditActive,
        onView: handleClickViewActive,
    });

    return (
        <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
            <PageTitle title="Ativos orais" />
            <Loading open={openBackdrop} />

            <AdminPageHeader
                title="Produtos orais"
                subtitle="Nutricosméticos e produtos de uso oral."
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddRounded />}
                        onClick={openCreate}
                        sx={{ height: 44, borderRadius: "12px", fontWeight: 600 }}
                    >
                        Novo produto oral
                    </Button>
                }
            />

            <OralFormModal
                open={formOpen}
                onClose={closeForm}
                productViewModel={productViewModel}
                setProductViewModel={setProductViewModel}
                productViewInitial={productViewInitial}
                productSchema={productSchema}
                formik={formik}
                btnSaveDisabled={btnSaveDisabled}
                selectedClasses={selectedClasses}
                filterArray={filterArray}
                setClasses={setClasses}
                saveFilter={saveFilter}
                handleAddClass={handleAddClass}
                handleRemoveClass={handleRemoveClass}
                autoCompletefilter={autoCompletefilter}
            />

            {/* ── Search / filter bar ── */}
            <AdminFilterBar
                search={searchTerm}
                onSearch={(v) => {
                    setSearchTerm(v);
                    setPage(1);
                }}
                placeholder="Buscar por nome"
                count={countLabel(filteredActives.length, allActives.length)}
                filters={
                    <>
                        <TextField
                            select
                            size="small"
                            label="Classificação"
                            value={selectedClassification}
                            onChange={(e) => {
                                setSelectedClassification(e.target.value);
                                setPage(1);
                            }}
                            sx={{ minWidth: 180 }}
                        >
                            <MenuItem value="">Todas as classificações</MenuItem>
                            {distinctClassifications.map((c) => (
                                <MenuItem key={c} value={c}>
                                    {c}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            size="small"
                            label="Período"
                            value={selectedPeriod}
                            onChange={(e) => {
                                setSelectedPeriod(e.target.value);
                                setPage(1);
                            }}
                            sx={{ minWidth: 140 }}
                        >
                            <MenuItem value="ambos">{getPeriodLabel("ambos")}</MenuItem>
                            <MenuItem value="dia">Dia</MenuItem>
                            <MenuItem value="noite">Noite</MenuItem>
                        </TextField>
                    </>
                }
            />

            {/* ── List table ── */}
            <DataTable<OralModel>
                columns={tableColumns}
                rows={pagedActives}
                rowKey={(row) => String(row.id)}
                loading={openBackdrop}
                page={page}
                pageSize={pageSize}
                totalRows={filteredActives.length}
                onPageChange={setPage}
                countLabel={countLabel(filteredActives.length, allActives.length)}
                minWidth={640}
                emptyState={
                    <EmptyState
                        title="Nenhum produto oral encontrado"
                        description={
                            searchTerm || selectedClassification || selectedPeriod !== "ambos"
                                ? "Tente outros filtros."
                                : "Cadastre um novo produto oral para começar."
                        }
                        actionLabel={!searchTerm && !selectedClassification && selectedPeriod === "ambos" ? "Novo produto oral" : undefined}
                        onAction={!searchTerm && !selectedClassification && selectedPeriod === "ambos" ? openCreate : undefined}
                    />
                }
            />

            <Dialog open={open} onClose={() => setOpen(false)}>
                <OralDetail detail={oralModelToDetails(selectedProduct)} onClose={() => setOpen(false)} />
            </Dialog>

            <MessageDialog
                emoji={dialogModel.emoji}
                open={dialogModel.open}
                title={dialogModel.title}
                message={dialogModel.message}
                onConfirm={dialogModel.onConfirm}
                confirmButtonText={dialogModel.confirmButtonText}
            />
        </Box>
    );
};
